import React, { useEffect, useState } from "react";
import { ProgressBar } from "react-bootstrap";
import Blue_btn from "../../common_components/common_btn/blue_btn/Blue_btn";
import Blue_border_button from "../../common_components/common_btn/blue_border_button/Blue_border_button";
import StudentRegistration_stap_1 from "./studentRegistration_stap_1/StudentRegistration_stap_1";
import StudentRegistration_stap_2 from "./studentRegistration_stap_2/StudentRegistration_stap_2";
import StudentRegistration_stap_3 from "./studentRegistration_stap_3/StudentRegistration_stap_3";
import StudentRegistration_stap_4 from "./studentRegistration_stap_4/StudentRegistration_stap_4";
import StudentRegistration_stap_5 from "./studentRegistration_stap_5/StudentRegistration_stap_5";
import { useDispatch, useSelector } from "react-redux";
import { useFieldArray, useForm } from "react-hook-form";
import {
  Create1,
  GetRegistration1,
  Create2,
  GetRegistration2,
  Create3,
  GetRegistration3,
  Create4,
  GetRegistration4,
  Create5,
  GetRegistration5,
} from "../../../features/admin/student/studentauth/Slice";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const StudentRegistration = () => {
  const dispatch = useDispatch();
  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  const { getUserData1 } = useSelector(
    (state) => state.studentapplication.studentregistration,
  );

  //  MUST COME FIRST
  const {
    register,
    handleSubmit,
    setValue,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      academic_info: [
        {
          school_selection: "",
          program_name: "",
          enrollment_status: "",
          education_level: "",
          academic_year: "",
          student_id_number: "",
        },
      ],
    },
  });

  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: "academic_info",
  });

  //  Resume logic
  useEffect(() => {
    if (getUserData1) {
      Object.keys(getUserData1).forEach((key) => {
        if (key === "dob" && getUserData1.dob) {
          //  format date for input[type="date"]
          const formattedDob = getUserData1.dob.split("T")[0];
          setValue("dob", formattedDob);
        } else if (key === "show_password") {
          //  map show_password to password field
          setValue("password", getUserData1.show_password);
        } else {
          setValue(key, getUserData1[key]);
        }
      });

      if (getUserData1.last_completed_step) {
        setStep(Math.min(getUserData1.last_completed_step + 1, 5));
      }
    }
  }, [getUserData1, setValue]);

  // Prefill Step 2
  const getUserData2 = useSelector(
    (state) => state.studentapplication.studentregistration.getUserData2,
  );

  // Prefill Step 2
  useEffect(() => {
    if (getUserData2) {
      Object.keys(getUserData2).forEach((key) => {
        if (key === "gender_id" && getUserData2.gender_id) {
          setValue("gender_id", {
            label: getUserData2.gender_name,
            value: getUserData2.gender_id,
          });
        } else {
          setValue(key, getUserData2[key]);
        }
      });

      if (getUserData2.last_completed_step) {
        setStep(Math.min(getUserData2.last_completed_step + 1, 5));
      }
    }
  }, [getUserData2, setValue]);

  // Correct useSelector for step 3
  const getUserData3 = useSelector(
    (state) => state.studentapplication.studentregistration.getUserData3,
  );

  // Prefill Step 3
  useEffect(() => {
    if (getUserData3) {
      // Prefill all fields explicitly
      setValue("passport_number", getUserData3.passport_number || "");
      setValue(
        "passport_issue_country",
        getUserData3.passport_issue_country || "",
      );
      setValue(
        "passport_expiry_date",
        getUserData3.passport_expiry_date
          ? getUserData3.passport_expiry_date.split("T")[0]
          : "",
      );
      setValue("passport_address", getUserData3.passport_address || "");
      setValue(
        "passport_current_address",
        getUserData3.passport_current_address || "",
      );
      setValue("passport_contact_no", getUserData3.passport_contact_no || "");
      setValue("guardian_name", getUserData3.guardian_name || "");
      setValue("guardian_phone", getUserData3.guardian_phone || "");
      setValue("guardian_email", getUserData3.guardian_email || "");
      setValue("relation", getUserData3.relation || "");

      if (getUserData3.last_completed_step) {
        setStep(Math.min(getUserData3.last_completed_step + 1, 5));
      }
    }
  }, [getUserData3, setValue]);

  // Correct useSelector for step 4
  const getUserData4 = useSelector(
    (state) => state.studentapplication.studentregistration.getUserData4,
  );

  // Prefill Step 4
  useEffect(() => {
    if (getUserData4 && getUserData4.length) {
      replace(
        getUserData4.map((item) => ({
          id: item.id,
          school_selection: item.school_selection ?? "",
          program_name: item.program_name ?? "",

          // ✅ FIX HERE
          enrollment_status: item.enrollment_status === true ? "1" : "0",

          education_level: item.education_level ?? "",
          academic_year: item.academic_year
            ? item.academic_year.split("T")[0]
            : "",
          student_id_number: item.student_id_number ?? "",
        })),
      );
    }
  }, [getUserData4, replace]);

  const getUserData5 = useSelector(
    (state) => state.studentapplication.studentregistration.getUserData5,
  );

  useEffect(() => {
    if (getUserData5) {
      Object.keys(getUserData5).forEach((key) => {
        setValue(key, getUserData5[key]);
      });
    }
  }, [getUserData5, setValue]);

  // Fetch Step 1 + Step 2 on reload
  useEffect(() => {
    const storedUserId = Cookies.get("student_user_id");
    if (storedUserId) {
      dispatch(GetRegistration1(storedUserId));
      dispatch(GetRegistration2(storedUserId));
      dispatch(GetRegistration3(storedUserId));
      dispatch(GetRegistration4(storedUserId));
    }
  }, [dispatch]);

  //  Fetch step-1 data on reload
  useEffect(() => {
    const storedUserId = Cookies.get("student_user_id");
    if (storedUserId) {
      dispatch(GetRegistration1(storedUserId));
    }
  }, [dispatch]);

  //  MAIN SUBMIT HANDLER
  const onSubmit = async (data) => {
    try {
      const userId = Cookies.get("student_user_id");

      //  Only block steps AFTER step 1
      if (step > 1 && !userId) {
        console.error("User not created yet. Complete Step 1.");
        return;
      }

      // ================= STEP 1 =================
      if (step === 1) {
        const formData = new FormData();
        const existingUserId = Cookies.get("student_user_id");

        if (existingUserId) {
          formData.append("user_id", existingUserId);
        }

        formData.append("name", data.name);
        formData.append("last_name", data.last_name);
        formData.append("email", data.email);
        formData.append("dob", data.dob);
        formData.append("contact_no", data.contact_no);
        formData.append("password", data.password);
        formData.append("role_id", data.role_id);

        try {
          const res = await dispatch(Create1(formData)).unwrap();
          const createdUserId = res?.data?.user_id;

          if (!existingUserId && createdUserId) {
            Cookies.set("student_user_id", createdUserId);
          }

          await dispatch(GetRegistration1(existingUserId || createdUserId));

          setStep(2);
          return;
        } catch (err) {
          // ------------------ Handle backend validation errors ------------------
          const backendMessage =
            err?.errors || err?.message || "Registration failed";

          if (backendMessage.toLowerCase().includes("email")) {
            setError("email", { type: "manual", message: backendMessage });
          } else if (backendMessage.toLowerCase().includes("contact")) {
            setError("contact_no", { type: "manual", message: backendMessage });
          } else {
            console.error("Unknown error:", backendMessage);
          }
          return;
        }
      }

      // ================= STEP 2 =================
      if (step === 2) {
        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("gender_id", data.gender_id?.value || data.gender_id); // react-select value
        formData.append("birth_country", data.birth_country);
        formData.append("birth_state", data.birth_state);
        formData.append("birth_city", data.birth_city);
        formData.append("nationality", data.nationality);

        const res = await dispatch(Create2(formData));

        if (res?.success) {
          // fetch step 2 data to prefill
          await dispatch(GetRegistration2(userId));

          // move to step 3
          setStep(3);
        }
        return;
      }

      // ================= STEP 3 =================
      if (step === 3) {
        const formData = new FormData();
        formData.append("user_id", userId);
        formData.append("passport_number", data.passport_number);
        formData.append("passport_issue_country", data.passport_issue_country);
        formData.append("passport_expiry_date", data.passport_expiry_date);
        formData.append("passport_address", data.passport_address);
        formData.append(
          "passport_current_address",
          data.passport_current_address || "",
        );
        formData.append("passport_contact_no", data.passport_contact_no);
        formData.append("guardian_name", data.guardian_name);
        formData.append("relation", data.relation);
        formData.append("guardian_phone", data.guardian_phone);
        formData.append("guardian_email", data.guardian_email);

        const res = await dispatch(Create3(formData));

        if (res?.success) {
          // fetch step 3 data to prefill if needed
          await dispatch(GetRegistration3(userId));

          // move to step 4
          setStep(4);
        }
        return;
      }

      if (step === 4) {
        const academicData = data.academic_info.map((item) => ({
          id: item.id || null,
          user_id: userId,
          school_selection: item.school_selection,
          program_name: item.program_name,
          enrollment_status: Number(item.enrollment_status), // ✅ 1 or 0
          education_level: item.education_level,
          academic_year: item.academic_year,
          student_id_number: item.student_id_number,
        }));

        const res = await dispatch(Create4({ data: academicData }));

        if (res?.success) {
          await dispatch(GetRegistration4(userId));
          setStep(5);
        }
      }

      // ================= STEP 5 =================
      if (step === 5) {
        const userId = Cookies.get("student_user_id");

        const payload = {
          user_id: userId,
          study_abroad_objective: data.study_abroad_objective,
          country: data.country,
          previous_international_experience: Number(
            data.previous_international_experience,
          ), // ✅ 1 or 0
        };

        const res = await dispatch(Create5(payload));

        if (res?.success) {
          await dispatch(GetRegistration5(userId));

          // ✅ remove cookie
          Cookies.remove("student_user_id");

          // ✅ success popup for 2 seconds and auto redirect
          Swal.fire({
            icon: "success",
            title: "Registration Completed",
            text: "Your registration has been successfully completed.",
            timer: 2000,
            timerProgressBar: true,
            showConfirmButton: false, // remove button
            didClose: () => {
              navigate("/"); // redirect after 2 seconds
            },
          });
        }

        return;
      }

      // ================= STEP 3–4 =================
      if (step < 5) {
        setStep(step + 1);
        return;
      }

      // ================= STEP 5 =================
      console.log("FINAL SUBMIT", data);
      // call registration5 API here
    } catch (error) {
      console.error("Form error:", error);
    }
  };

  return (
    <section className="StudentRegistration common_step_form_wrapper">
      <div className="login_form_div">
        <div className="login_card">
          <div className="hotel-form-card">
            <div className="hotel-progress-wrapper">
              <ProgressBar now={(step / 5) * 100} />
              <span>{step} / 5</span>
            </div>

            <form onSubmit={handleSubmit(onSubmit)}>
              {step === 1 && (
                <StudentRegistration_stap_1
                  register={register}
                  errors={errors}
                  setValue={setValue}
                />
              )}

              {step === 2 && (
                <StudentRegistration_stap_2
                  register={register}
                  errors={errors}
                  control={control}
                />
              )}

              {step === 3 && (
                <StudentRegistration_stap_3
                  register={register}
                  errors={errors}
                />
              )}

              {step === 4 && (
                <StudentRegistration_stap_4
                  register={register}
                  errors={errors}
                  fields={fields}
                  append={append}
                  remove={remove}
                />
              )}

              {step === 5 && (
                <StudentRegistration_stap_5
                  register={register}
                  errors={errors}
                />
              )}

              <div className="btn-group">
                {step > 1 && (
                  <Blue_border_button
                    button_text="Back"
                    onClick={() => setStep(step - 1)}
                  />
                )}

                <Blue_btn
                  btn_text={step === 5 ? "Submit" : "Next"}
                  type="submit"
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudentRegistration;
